/**
 * @deprecated Use mergeRefs from "merge-refs" instead
 */
export const mergeRefs = (refs: any) => (value: any) => {
  refs.forEach((ref: any) => {
    if (typeof ref === "function") {
      ref(value);
    } else if (ref != null) {
      ref.current = value;
    }
  });
};
